<template>
  <div class="list-card van-hairline--surround" @click="linkTo">
    <div class="list-line clear">
      <p class="list-title fl">经销商:</p>
      <p class="list-content fl">{{data.deptName}}</p>
    </div>
    <div class="list-line clear">
      <p class="list-title fl">活动:</p>
      <p class="list-content fl">{{data.Name}}</p>
    </div>
    <div class="list-line clear">
      <p class="list-title fl">时间:</p>
      <p class="list-content fl">{{(data.U_RangeTime || "").replace(/-/g,'/').replace(',','-')}}</p>
    </div>
    <div class="list-line clear">
      <p class="list-title fl">地点:</p>
      <p class="list-content fl">{{data. U_CampPlace}}</p>
    </div>
    <div class="list-line clear">
      <p class="list-title fl">预算:</p>
      <p class="list-content fl">{{$numeral(data.totalAmount).format('0,0')}}</p>
    </div>
    <div class="list-line clear item1">
      <p class="list-title fl">活动报告:</p>
      <p class="list-content fl">{{data.rptCnt>0?'已提交':'未提交'}}</p>
    </div>
    <div class="list-line flex">
      <p >活动后30天销售情况:</p>
      <p class="list-content ">{{data.monthSalesCnt>0?'已提交':'未提交'}}</p>
    </div>
    <!--<div class="flex">-->
      <!--<div class="list-line clear item1">-->
        <!--<p class="list-title fl">活动报告:</p>-->
        <!--<p class="list-content fl">{{data.rptCnt>0?'已提交':'未提交'}}</p>-->
      <!--</div>-->
      <!--<div class="list-line clear flex">-->
        <!--<p >活动后30天销售情况:</p>-->
        <!--<p class="list-content ">{{data.monthSalesCnt>0?'已提交':'未提交'}}</p>-->
      <!--</div>-->
    <!--</div>-->

    <div class="list-status">
      {{data.approvalStatusName}}
      <p v-if="data.U_ApprovalStatus=='W'&&data.auditName">({{data.auditName}})</p>
    </div>

  </div>
</template>
<script>
    export default{
        data(){
            return {}
        },
        props:{
          data:Object,
          menuId : ''
        },
        methods:{
          linkTo(){
              var approvalStatus = this.data.U_ApprovalStatus;
              if(this.data.U_CreatedId==this.$wxuserUtil.getUserId()&&approvalStatus=="M"){
                this.$router.push('/active/apply?id='+this.data.U_CampaignId)
              }else{
//                this.$router.push('/active/apply?id='+this.data.U_CampaignId)
                this.$router.push('/active/activeDetail?id='+this.data.U_CampaignId + "&menuId=" + this.menuId)
              }
          }
        }
    }
</script>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../../style/pageStyle/pageView-activeList.less";
</style>



// WEBPACK FOOTER //
// src/components/active/component/activeListCard.vue